import { defineStore } from 'pinia'
export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      user: null,
      initialLogin: false,
      kbToken: null,
    }
  },

  actions: {
    setAuthUser(data) {
      this.user = data
      this.initialLogin = true
    },
    setKbToken(token) {
      this.kbToken = token
    },
    loadAuthUser() {
      try {
        const app = useNuxtApp()
        const { data } = app.$axios.get(`/me`, {
          withCredentials: true,
        })
        this.user = data
      } catch (error) {
        this.$toast.error(error)
      }
    },
    async updateAccount(data) {
      try {
        const app = useNuxtApp()
        const response = await app.$auth.updateAccount(data)
        response.resolved = true
        return response
      } catch (e) {
        return e
      }
    },
  },

  getters: {
    getAuthUser: (state) => {
      return state.user
    },
    getInitialLogin: (state) => {
      return state.initialLogin
    },
    getKbToken: (state) => {
      return state.kbToken
    },
    isOwner(state) {
      if (state.user) {
        if (
          state.user.role === 'owner' ||
          state.user.role === 'coowner' ||
          state.user.role === 'reader'
        ) {
          return true
        } else {
          return false
        }
      }
    },
    isReadOnly(state) {
      if (state.user && state.user.role === 'reader') {
        return true
      } else {
        return false
      }
    },
  },
})
